export default __webpack_public_path__ + "static/media/footer-news1.a5ee19a6.png";